import axios from "axios";
import ContextService from "../services/ContextService";
import { AuthService } from "../services/authService";


export const handleTokenExpiration = async <T = any>(
  retyFunction: () => Promise<T[]>
): Promise<T[]> => {
  try {
    const authService = new AuthService();
    const authResult = await authService.acquireTokenSilently();
    const Token = authResult?.accessToken;

    if (Token) {
      localStorage.setItem("CurrentToken", Token);
      return await retyFunction();
    } else {
      return [];
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
    return [];
  }
};

export const fetchRequestData = async (guidId: string): Promise<any[]> => {
    const token = localStorage.getItem("CurrentToken");
    const url = `/_api/web/lists/getbytitle('CLM365Request')/items?$top=5000&$select=*,AttachmentFiles/FileName,AttachmentFiles&$expand=AttachmentFiles&$expand=AttachmentFiles&$orderby=Created desc&$filter=Guid_ID eq '${guidId}'`;
  
    try {
      const response = await axios.get(`${ContextService.GetUrl()}${url}`, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      });
  
      // console.log(response.data); // Inspect the response to confirm structure
  
      // Check if 'value' exists in the response and return it
      const items = response.data?.value || [];
      return items;
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => fetchRequestData(guidId));
    } else {
    console.error("API failed:", error);
    return [];
    }
   }
  };

  export const fetchTaskRequestData = async (guidId: string): Promise<any[]> => {
    const token = localStorage.getItem("CurrentToken");
    const url = `/_api/web/lists/getbytitle('CLM365ContractTasks')/items?$top=5000&$select=*&$orderby=Created desc&$filter=RequestGuid eq '${guidId}'`;
  
    try {
      const response = await axios.get(`${ContextService.GetUrl()}${url}`, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      });
  
      // console.log(response.data); // Inspect the response to confirm structure
  
      // Check if 'value' exists in the response and return it
      const items = response.data?.value || [];
      return items;
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => fetchTaskRequestData(guidId));
    } else{
      console.error("Error fetching data:", error);
      return [];
     }
    }
  };


  export const fetchRequestListData = async (): Promise<any[]> => {
    const token = localStorage.getItem("CurrentToken");
    const url = `/_api/web/lists/getbytitle('CLM365Request')/items?$top=5000&$select=*,ID,Title,Guid_ID,File_Name,Draft_Type,Contract_Type,ActualFileName&$orderby=Created desc&$filter=Request_Type eq 'Contract'`;
  
    try {
      const response = await axios.get(
        `${ContextService.GetUrl()}${url}`,
        {
          headers: {
            Accept: "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      // console.log(response.data);
  
      const items = response.data?.value || [];
      return items;
    } catch (error) {
       const status = error?.response?.status;
    if ([401, 402, 403].includes(status)) {
        return await handleTokenExpiration(fetchRequestListData);
    } else{
    console.error("Error fetching contract template data:", error);
    return [];
    }
   }
  };
  


  export async function getFileById(FileName) {
    try {
      const token = localStorage.getItem("CurrentToken");
      const SiteURL = localStorage.getItem("SiteURL");
      // console.log(FileName)
      // console.log(SiteURL)
      const response = await axios.get(
        `${SiteURL}/_api/web/lists/getbytitle('CLM365RequestDraft')/items?$filter=FileLeafRef eq '${FileName}'&$expand=File`,{
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json;odata=verbose",
          },
        }
      );
 
      const e = response?.data?.d;
      if (!e || !e.File) {
        console.log('File Not Found')
      }
      const file = e.results[0]?.File;
      const ServerRelativeUrl = file?.ServerRelativeUrl
 
      return {
        ServerRelativeUrl,
        file
      };
     
    } catch (error) {
      console.error("error", error);
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => getFileById(FileName));
    } else{
      // throw error;
      const empty=""
      return {
        empty,
      };
     }
    }
  }
  export async function downloadFileBlob(serverRelativeUrl) {
    try{
  const token = localStorage.getItem("CurrentToken");
  const SiteURL = localStorage.getItem("SiteURL");

  const response = await axios.get(`${SiteURL}/_api/web/getfilebyserverrelativeurl('${serverRelativeUrl}')/$value`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });

      return response.data; // This is the Blob
    } catch(error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => downloadFileBlob(serverRelativeUrl));
    }
    }
  }

  export async function getGeneralData() {
  try {
    const token = localStorage.getItem("CurrentToken");
    const url = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365General')/items?$select=Role,BusinessUnit,ClauseType,RequestActions,OrganizationInfo&$filter=Title eq 'GeneralData'`;

    const response = await axios.get(url, {
      headers: {
        Accept: "application/json;odata=nometadata",
        "odata-version": "",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(getGeneralData());
    } else {
    console.error("Error fetching role data:", error);
    throw error;
    }
  }
};

 
  export const sortArrayAscendingorder = (array,value) => {
    if(value == true){
      return Array.isArray(array) ? (array?.sort((a, b) => {
        const textA = a?.Name?.props?.children?.props?.text?.toLowerCase();
        const textB = b?.Name?.props?.children?.props?.text.toLowerCase();
        const numA = parseFloat(a?.text);
        const numB = parseFloat(b?.text);
        if (!isNaN(numA) && isNaN(numB)) {
          return 1;
        }
        if (isNaN(numA) && !isNaN(numB)) {
          return -1;
        }
    
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
    
        return textA?.localeCompare(textB, "en-US", { caseFirst: "upper" });
      })):[]
    }else if(value == "props?.children"){
      return Array.isArray(array) ? (array?.sort((a, b) => {
        const textA = a?.clauseName?.props?.children.toLowerCase();
        const textB = b?.clauseName?.props?.children?.toLowerCase();
        const numA = parseFloat(a?.text);
        const numB = parseFloat(b?.text);
        if (!isNaN(numA) && isNaN(numB)) {
          return 1;
        }
        if (isNaN(numA) && !isNaN(numB)) {
          return -1;
        }
    
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
    
        return textA?.localeCompare(textB, "en-US", { caseFirst: "upper" });
      })):[]
    }else{
      return Array.isArray(array) ? (array?.sort((a, b) => {
        const textA = a?.[value]?.toLowerCase();
        const textB = b?.[value]?.toLowerCase();
        const numA = parseFloat(a?.text);
        const numB = parseFloat(b?.text);
  
    
        if (!isNaN(numA) && isNaN(numB)) {
          return 1;
        }
        if (isNaN(numA) && !isNaN(numB)) {
          return -1;
        }
    
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
    
        return textA?.localeCompare(textB, "en-US", { caseFirst: "upper" });
      })):[]
    }
    };

    export async function getCluaseLibraryData() {
      return new Promise(async (resolve, reject) => {
        const url = ContextService.GetUrl() + "/_api/web/lists/getbytitle('CLM365ClauseLibrary')/items?$select=Modified,Id,ClauseType,ClauseName,Question,ClauseTitle,Message,Editor/Id,Editor/Title&$expand=Editor";
        try {
          const token = localStorage.getItem("CurrentToken");
          const response = await axios.get(url, {
            headers: {
              Accept: "application/json;odata=nometadata",
              "odata-version": "",
              Authorization: `Bearer ${token}`,
            }
          });
          const data = response.data;
          const allClauseData: any[] = [];
    
          if (data.value && data.value.length > 0) {
            data.value.forEach((item: any) => {
              allClauseData.push({
                clauseType: item.ClauseType,
                clauseName: item.ClauseName,
                tags: item.Question,
                message: JSON.parse(item.Message || "[]"),
              });
            });
          }
          resolve(allClauseData);
        } catch (error: any) {
          reject(error);
        }
      });
    }

type UserHighlightsMap = {
  [email: string]: string[];
};
    export async function getSelectedText(): Promise<{
  text: string;
  ParagraphIndex: number | null;
  StartIndex: number | null;
  EndIndex:number|null;
}> {
  const returnText = {
    text: "",
    ParagraphIndex: null,
    StartIndex: null,
    EndIndex:null
  };

  try {
    return await Word.run(async (context) => {
      const selection = context.document.getSelection();
      const paragraphs = context.document.body.paragraphs;

      selection.load("text");
      paragraphs.load("items");

      await context.sync();

      const selectionText = selection.text.trim();
      let selectedParagraphIndex: number | null = null;
      let startIndexInParagraph: number | null = null;
      let endIndexInParagraph:number|null=null;

      for (let i = 0; i < paragraphs.items.length; i++) {
        const paraText = paragraphs.items[i].text;
        const index = paraText.indexOf(selectionText);

        if (index !== -1) {
          selectedParagraphIndex = i;
          startIndexInParagraph = index;
          endIndexInParagraph=index+ selectionText.length
          break;
        }
      }

      const result = {
        text: selectionText,
        ParagraphIndex: selectedParagraphIndex,
        StartIndex: startIndexInParagraph,
        EndIndex:endIndexInParagraph
      };

      // console.log("Selected Text Info:", result);
      return result;
    });
  } catch (error) {
    console.error("Error getting selected text:", error);
    return returnText;
  }
}

export const readCurrentDocument = (): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 }, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const file = result.value;
        const sliceCount = file.sliceCount;
        const slices: any[] = [];
 
        let getSlice = (index: number) => {
          file.getSliceAsync(index, (sliceResult) => {
            if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
              const sliceData = sliceResult.value.data;
              slices[index] = new Uint8Array(sliceData);
 
              if (slices.filter(Boolean).length === sliceCount) {
                file.closeAsync();
                const blob = new Blob(slices, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                resolve(blob);
              } else {
                getSlice(index + 1);
              }
            } else {
              reject(sliceResult.error.message);
            }
          });
        };
 
        getSlice(0);
      } else {
        reject(result.error.message);
      }
    });
  });
};      



export async function createReviewDocsForUsers(userHighlightsMap:UserHighlightsMap) {
  try {
    for (const [email, highlights] of Object.entries(userHighlightsMap)) {
      await Word.run(async (context) => {
        const docBody = context.document.body;
        docBody.clear();

        docBody.insertParagraph(`Highlights for ${email}`, Word.InsertLocation.start).font.set({
          bold: true,
          size: 16,
        });

        highlights.forEach((text, index) => {
          docBody.insertParagraph(`${index + 1}. ${text}`, Word.InsertLocation.end);
        });

        await context.sync();

        // Get the file as a compressed base64 format
        await context.sync();
        return new Promise((resolve, reject) => {
          Office.context.document.getFileAsync(
            Office.FileType.Compressed,
            { sliceSize: 65536 },
            (result) => {
              if (result.status === Office.AsyncResultStatus.Succeeded) {
                const file = result.value;
                let sliceCount = file.sliceCount;
                let slices = [];
                let sliceIndex = 0;

                const getSlice = () => {
                  file.getSliceAsync(sliceIndex, (sliceResult) => {
                    if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
                      slices.push(sliceResult.value.data);
                      sliceIndex++;

                      if (sliceIndex < sliceCount) {
                        getSlice();
                      } else {
                        file.closeAsync();
                        // Combine slices
                        const byteArray = new Uint8Array(slices.reduce((acc, val) => acc + val.length, 0));
                        let offset = 0;
                        slices.forEach((s) => {
                          byteArray.set(s, offset);
                          offset += s.length;
                        });

                        const blob = new Blob([byteArray], { type: "application/vnd.ms-word.document.macroEnabled.12" });
                        // console.log("Generated Word Blob for:", email);
                        resolve({ email, blob });
                      }
                    } else {
                      reject(sliceResult.error);
                    }
                  });
                };

                getSlice();
              } else {
                reject(result.error);
              }
            }
          );
        });
      });
    }
  } catch (error) {
    console.error("Error generating Word blob:", error);
  }
}


export function highlightInWordXml(xmlString, target) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");

  const paragraphs = xmlDoc.getElementsByTagName("w:p");
  const targetParagraph = paragraphs[target.ParagraphIndex];
  const textToHighlight = target.text;
  const startIndex = target.StartIndex;

  let currentCharIndex = 0;
  let highlightStart = startIndex;
  let highlightEnd = startIndex + textToHighlight.length;
  let matchFound = false;

  const runs:any = targetParagraph.getElementsByTagName("w:r");

  for (let run of runs) {
    const textNode = run.getElementsByTagName("w:t")[0];
    if (!textNode) continue;

    const text = textNode.textContent;
    const runStart = currentCharIndex;
    const runEnd = currentCharIndex + text.length;

    // If the run overlaps the highlight range
    if (runEnd > highlightStart && runStart < highlightEnd) {
      matchFound = true;

      // Add or update <w:rPr> with highlight
      let rPr = run.getElementsByTagName("w:rPr")[0];
      if (!rPr) {
        rPr = xmlDoc.createElementNS("http://schemas.openxmlformats.org/wordprocessingml/2006/main", "w:rPr");
        run.insertBefore(rPr, run.firstChild);
      }

      // Create highlight element
      const highlight = xmlDoc.createElementNS("http://schemas.openxmlformats.org/wordprocessingml/2006/main", "w:highlight");
      highlight.setAttribute("w:val", "yellow");
      rPr.appendChild(highlight);
    }

    currentCharIndex += text.length;
  }

  if (!matchFound) {
    console.warn("Text to highlight not found in expected range.");
  }

  const serializer = new XMLSerializer();
  return serializer.serializeToString(xmlDoc);
}



export async function uploadFilesInBatch(filesDataArray, folderName) {
  const documentLibraryName = "CLM365TaskAttachment"; // Replace with your document library name
  const newFolderName = folderName; // The name of the new folder
  const token = localStorage.getItem("CurrentToken");
const siteUrl = localStorage.getItem("SiteURL");
 const siteName=siteUrl.split('/sites/')[1]||""

  const createFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${documentLibraryName}')/rootfolder/folders`;

  // Payload to specify the folder details
  let folderPayload;
  if(siteName.includes('/')){
     folderPayload = {
      "ServerRelativeUrl": `/sites/${siteName}${documentLibraryName}/${newFolderName}` // Adjust path as necessary
  };
  }else{
    folderPayload = {
      "ServerRelativeUrl": `/sites/${siteName}/${documentLibraryName}/${newFolderName}` // Adjust path as necessary
  };
  }


  // Send the POST request to create the new folder
  try {
      const response = await axios.post(createFolderUrl, folderPayload, {
          headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json"
          }
      });

      // console.log('Folder created successfully:', response.data);
      if (response.data.ServerRelativeUrl) {
          const folderUrl = `${response.data.ServerRelativeUrl}`;

          // Use Promise.all to upload files concurrently
          const uploadPromises = filesDataArray.map(async (file) => {
              const fileName = `${file?.GUID}`;  // Make the file name unique using GUID and timestamp
              const fileData = file?.FileContent;  // File object to send

              let finalTemplateLibrary = {
                  TaskID: folderName,
                  File_Name: file?.FileName,
                  File_Guid: file?.GUID?.split('.')[0],
                  AttachmentIntName: file?.IntName,
              };

              // Define the URL to upload the file to SharePoint
              const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;

              try {
                  // Send the POST request to upload the file
                  const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
                      headers: {
                          Authorization: `Bearer ${token}`,
                          Accept: "application/json",
                          "Content-Type": "application/octet-stream"  // Set content type to binary stream
                      }
                  });

                  if (uploadFileResponse.data.ServerRelativeUrl) {
                      const uploadedFileUrl = uploadFileResponse.data.ServerRelativeUrl;
                      const updateMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;
                      const getFileMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;

                      const fileMetadataResponse = await axios.get(getFileMetadataUrl, {
                          headers: {
                              Authorization: `Bearer ${token}`,
                              Accept: "application/json"
                          }
                      });

                      const fileETag = fileMetadataResponse.headers['etag'];

                      // Send the PATCH request to update metadata
                      const updateMetadataResponse = await axios.patch(updateMetadataUrl, {
                          TaskID: finalTemplateLibrary?.TaskID,
                          File_Name: finalTemplateLibrary?.File_Name,
                          File_Guid: finalTemplateLibrary?.File_Guid,
                          AttachmentIntName: finalTemplateLibrary?.AttachmentIntName
                      }, {
                          headers: {
                              Authorization: `Bearer ${token}`,
                              Accept: "application/json",
                              "Content-Type": "application/json",
                              "If-Match": fileETag  
                          }
                      });

                      if (updateMetadataResponse.status === 200) {
                          // console.log("File uploaded and metadata updated successfully.");
                      } else {
                          console.error("Failed to update metadata.");
                      }
                  }

                  // console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
              } catch (error) {
                  console.error(`Error uploading file ${fileName}:`, error);
              }
          });

          // Wait for all files to be uploaded
          await Promise.all(uploadPromises);

      }

  } catch (error) {
      console.error('Error creating folder:', error);
  }
}


export const postTaskInBatch = async (tasksData) => {
  try {
    const token = localStorage.getItem("CurrentToken");

    const updateUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365ContractTasks')/items`;

    for (const task of tasksData) {
      try {
        const response = await axios.post(updateUrl, task, {
          headers: {
            Accept: "application/json;odata=nometadata",
            "Content-Type": "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`,
          },
        });

        // console.log("Task posted successfully:", response.data);
      } catch (error) {
        console.error("Error posting task:", task, error.response?.data || error.message);
      }
    }
  } catch (globalError) {
    const status = globalError?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => postTaskInBatch(tasksData));
    } else {
      console.error("Batch posting failed:", globalError.message);
    }
  }
};


export const updateListItem = async (
  listName: string,
  finalTemp: any,
  RowID: string
): Promise<boolean> => {
  try {
    const token = localStorage.getItem("CurrentToken");

    const updateUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${listName}')/items('${RowID}')`;

    const response = await axios.post(updateUrl, JSON.stringify(finalTemp), {
      headers: {
        Accept: "application/json;odata=nometadata",
        "Content-Type": "application/json;odata=nometadata",
        "odata-version": "",
        Authorization: `Bearer ${token}`,
        "IF-MATCH": "*", // Allow overwrite
        "X-HTTP-Method": "MERGE", // Merge update
      },
    });

    // console.log("Item updated successfully:", response.data);
    return true;
  } catch (error: any) {
    console.error("Error updating the list item:", error.response?.data || error.message);
    return false;
  }
};

export  async function generateDocumentsForUsers(userHighlights, fileBlob) {
    const allUsersFiles = [];
     const JSZip = require("jszip");
    const zip = await JSZip.loadAsync(fileBlob);
    const documentXml = await zip.file("word/document.xml").async("string");

    for (const [email, highlights] of Object.entries(userHighlights)) {
      let modifiedXml = documentXml;

      (highlights as any).forEach((item) => {
        // console.log(item, "item");
        const paragraphs = modifiedXml.split("</w:p>");

        const index = item.ParagraphIndex;
        if (paragraphs[index]) {
          paragraphs[index] = paragraphs[index].replace(/<w:r(\s[^>]*)?>\s*(<w:rPr>)?/g, (match, attrs, hasRpr) => {
            if (hasRpr) {
              // Append highlight inside existing <w:rPr>
              return match.replace(/<w:rPr>/, '<w:rPr><w:highlight w:val="yellow"/>');
            } else {
              // Insert new <w:rPr> with highlight after <w:r>
              return `<w:r${attrs || ""}><w:rPr><w:highlight w:val="yellow"/></w:rPr>`;
            }
          });
        }

        modifiedXml = paragraphs.join("</w:p>");
      });

      const newZip = new JSZip();
      const entries = Object.keys(zip.files);
      for (const name of entries) {
        if (name === "word/document.xml") {
          newZip.file(name, modifiedXml);
        } else {
          const content = await zip.files[name].async("arraybuffer");
          newZip.file(name, content);
        }
      }

      const updatedBlob = await newZip.generateAsync({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // console.log(updatedBlob, `${email}_highlighted.docx`);

      allUsersFiles.push({
        userEmail: email,
        Blob: updatedBlob,
      });

      // const url = URL.createObjectURL(updatedBlob);
      //       const link = document.createElement("a");
      //     link.href = url;
      //     link.download = `${email}_highlighted.docx`;
      //     link.style.display = "none";
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      //     URL.revokeObjectURL(url);
      // downloadBlob(updatedBlob, `${email}_highlighted.docx`);
    }
    return allUsersFiles;
  }
export async function generateDocuments(
  fileBlob: Blob,
  updatedUnMatchingRisks
): Promise<Blob> {
  const JSZip = require("jszip");
  const zip = await JSZip.loadAsync(fileBlob);

  let documentXml = await zip.file("word/document.xml").async("string");

  updatedUnMatchingRisks.forEach(({ Clause, UpdatedClause }) => {
    // Escape XML special characters for safe regex
    const escapedClause = Clause.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // Create regex to find all occurrences of Clause
    const regex = new RegExp(escapedClause, "g");

    // Replace Clause with UpdatedClause directly
    documentXml = documentXml.replace(regex, UpdatedClause);
  });

  // Create new ZIP with updated document.xml
  const newZip = new JSZip();
  const entries = Object.keys(zip.files);

  for (const name of entries) {
    if (name === "word/document.xml") {
      newZip.file(name, documentXml);
    } else {
      const content = await zip.files[name].async("arraybuffer");
      newZip.file(name, content);
    }
  }

  const updatedBlob = await newZip.generateAsync({
    type: "blob",
    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });
  //  const url = URL.createObjectURL(updatedBlob);
  //           const link = document.createElement("a");
  //         link.href = url;
  //         link.download = `${'Risk'}_Updated.docx`;
  //         link.style.display = "none";
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //         URL.revokeObjectURL(url);
  return updatedBlob;
}

export const updateListData = async (listId, finalTemplate, listName) => {
  try {
    const token = localStorage.getItem("CurrentToken");
    if (!token) {
      throw new Error("Authentication token not found in localStorage.");
    }

    const updateUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${listName}')/items(${listId})`;

    const response = await axios.post(updateUrl, finalTemplate, {
      headers: {
        Accept: "application/json;odata=nometadata",
        "Content-Type": "application/json;odata=nometadata",
        "odata-version": "",
        "IF-MATCH": "*",
        "X-HTTP-Method": "MERGE",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating list item:", error);
    const status = error?.response?.status;
     if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => updateListData(listId, finalTemplate, listName));
    } else {
    return null;
  }
 }
};


export const getCurrentWordDocumentAsBase64 = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 }, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const file = result.value;
        const sliceCount = file.sliceCount;
        let slicesData: Uint8Array[] = [];
        let slicesFetched = 0;

        const getSlice = (index: number) => {
          file.getSliceAsync(index, (sliceResult) => {
            if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
              slicesData[index] = sliceResult.value.data;
              slicesFetched++;

              if (slicesFetched === sliceCount) {
                // All slices fetched
                const totalLength = slicesData.reduce((acc, slice) => acc + slice.length, 0);
                const fullData = new Uint8Array(totalLength);
                let offset = 0;

                for (const slice of slicesData) {
                  fullData.set(slice, offset);
                  offset += slice.length;
                }

                const binaryStr = Array.from(fullData).map(byte => String.fromCharCode(byte)).join('');
                const base64String = btoa(binaryStr);

                resolve(base64String);
              }
            } else {
              reject(sliceResult.error);
            }
          });
        };

        for (let i = 0; i < sliceCount; i++) {
          getSlice(i);
        }
      } else {
        reject(result.error);
      }
    });
  });
};

export const base64ToBlob = (base64: string, mimeType: string): Blob => {
  const byteChars = atob(base64);
  const byteNumbers = new Array(byteChars.length).fill(0).map((_, i) => byteChars.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

export  const fetchRiskTaskRequestData = async (guidId: string): Promise<any[]> => {
    const token = localStorage.getItem("CurrentToken");
    const url = `/_api/web/lists/getbytitle('CLM365ContractTasks')/items?$top=5000&$select=*&$orderby=Created desc&$filter=RiskDataGUID eq '${guidId}'`;
  
    try {
      const response = await axios.get(`${ContextService.GetUrl()}${url}`, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      });
  
      // console.log(response.data); // Inspect the response to confirm structure
  
      // Check if 'value' exists in the response and return it
      const items = response.data?.value || [];
      return items;
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => fetchRiskTaskRequestData(guidId));
    } else {
      console.error("Error fetching data:", error);
      return [];
    } 
   }
  };

export const saveDraftDocument = async (fileName, fileContent) => {
  const SiteURL = localStorage.getItem("SiteURL");
  const token = localStorage.getItem("CurrentToken");

  if (!fileName || !SiteURL) {
    console.error("Missing required parameters.");
    return false;
  }

  const url = `${SiteURL}/_api/web/getFolderByServerRelativeUrl('CLM365RequestDraft')/files/add(url='${fileName}',overwrite=true)`;

  try {
    const response = await axios.post(url, fileContent, {
      headers: {
        Accept: "application/json;odata=verbose",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/octet-stream"
      }
    });

    if (response.status === 200 || response.status === 201) {
      return true;
    } else {
      console.error("Unexpected response status:", response.status);
      return false;
    }
  } catch (error) {
    const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => saveDraftDocument(fileName, fileContent));
    } else {
    console.error("Error uploading file:", error);
    return false;
  } 
 }
};

export const fetchContractTempleteData = async (): Promise<any[]> => {
    const token = localStorage.getItem("CurrentToken");
    const apiUrl = `/_api/web/lists/getbytitle('CLM365Contract_Type')/items` +
        `?$select=ID,DocumentTypeField,ContractName,Status,BusinessUnit,FormFields,ConditionalField,ContractCode,Attachments,AttachmentFiles,LegalUser/Id,LegalUser/Title,BusinessUser/Id,BusinessUser/Title` +
        `&$expand=BusinessUser,LegalUser,AttachmentFiles`;

    try {
        const response = await axios.get(`${ContextService.GetUrl()}${apiUrl}`, {
            headers: {
                "Accept": "application/json;odata=nometadata",
                "odata-version": "",
                "Authorization": `Bearer ${token}`,
            },
        });

        const items: any[] = response.data?.value || [];
        return items;
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(fetchContractTempleteData);
    } else {
        console.error("Error fetching contract template data:", error);
        return [];
      }
    }
};
export const fetchAllTextFromWord = async () => {
    try {
      return await Word.run(async (context) => {
        const body = context.document.body;
        body.load("text");
        await context.sync();
  
        const documentText = body.text.trim();
        return documentText;
      });
    } catch (error) {
      throw new Error("Error extracting text from Word document.");
    }
  };
  

export const getDraftVersionHistory = async (fileName: string): Promise<string[]> => {
  try {
    const token = localStorage.getItem("CurrentToken");
    const siteUrl = localStorage.getItem("SiteURL");

    if (!siteUrl || !fileName) {
      throw new Error("Missing token, site URL, or file name");
    }

    const itemResponse = await axios.get(
      `${siteUrl}/_api/web/lists/getbytitle('CLM365RequestDraft')/items?$filter=FileLeafRef eq '${fileName}'&$select=Id`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json;odata=verbose",
        },
      }
    );

    const items = itemResponse.data.d.results;
    if (items.length === 0) throw new Error("No item found for the given file name.");

    const itemId = items[0].Id;

    const versionResponse = await axios.get(
      `${siteUrl}/_api/web/lists/getbytitle('CLM365RequestDraft')/items(${itemId})/versions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json;odata=verbose",
        },
      }
    );

    const versions = versionResponse.data.d.results;
    const versionHistory = versions.map((ver: any) => ver.VersionLabel);

    return versionHistory;
  } catch (error) {
    const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => getDraftVersionHistory(fileName));
    } else {
    console.error("Error fetching draft version history:", error);
    return [];
    }
  }
};

export const blankWordDocumentBase64=`data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,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`
